<template>
  <div>
    <div class="intro-x flex flex-col sm:flex-row items-center mt-8">
      <h2
        class="text-lg font-medium mr-auto"
        style="display: flex; align-items: center"
      >
        <span class="s-button" @click="getCreateAn">新建应用</span>
        <span class="hot">HOT</span>
        <span class="hot-text"
          >支持授信模式创建，点击了解什么是授信模式 >>></span
        >
      </h2>

      <div class="search-box">
        <el-input
          prefix-icon="el-icon-search"
          placeholder="智莺生活"
          size="small"
          v-model="searchValue"
          clearable
          @clear="onClears"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          style="margin-left: 8px"
          @click="onSearch"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="Menu-box">主应用列表</div>

    <div class="cate-box" v-if="cateData.length >= 1">
      <div class="cate-item" v-for="(item, index) in cateData" :key="index">
        <MyAppCate :item="item" :index="index"></MyAppCate>
      </div>
    </div>

    <div v-else class="kong-app">
      <div class="kongImg">
        <img src="../assets/images/kong-app.png" alt="" />
      </div>
      <div>还没有属于你的应用，快去创建吧</div>

      <div class="imgButton" @click="getCreateAn">立刻创建</div>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";
import MyAppCate from "../modules/myAppCate.vue";

export default {
  components: {
    MyAppCate,
  },
  data() {
    return {
      cateData: [],
      searchValue: "",
    };
  },

  mounted() {},
  activated() {
    this.getAppInit();
  },

  methods: {
    onClears: function () {
      this.getAppInit();
    },

    onSearch: function () {
      const loading = this.$loading({
        lock: true,
        text: "搜索中···",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      request({
        url: "/api/myApp/cate?keyword=" + this.searchValue,
      }).then((res) => {
        if (res.data.length >= 1) {
          res.data.sort((a, b) => {
            return a.expire > b.expire ? 1 : -1;
          });
        }
        this.cateData = res.data;
        this.cateData.forEach((item) => {
          item.isPop = false;
        });
        loading.close();
      });
    },

    // 获取应用-我的列表
    getAppInit: function () {
      request({
        url: "/api/myApp/cate",
      })
        .then((res) => {
          if (res.data.length >= 1) {
            res.data.sort((a, b) => {
              return a.expire > b.expire ? 1 : -1;
            });
          }
          this.cateData = res.data;
        })
        .catch((err) => {});
    },

    // 新建应用 -- >  跳转路由
    getCreateAn: function () {
      this.$router.push("/Dashboard/myApp/CreateAn");
    },
  },
};

 
</script>


<style lang="scss" scoped>
.Menu-box {
  width: 100%;
  overflow: hidden;
  margin: 30px 0 30px;
  box-sizing: border-box;
  font-size: 18px;
  color: #2d3748;
  font-weight: 500;
  display: flex;
} 

.s-button {
  width: 87px;
  text-align: center;
  line-height: 31px;
  height: 31px;
  background: #1890ff;
  color: #fff;
  font-size: 14px;
  border-radius: 7px;
  display: inline-block;
  cursor: pointer;
}

.s-button:active {
  background: #4ea6f8;
}

.hot {
  background: #ff2640;
  font-size: 10px;
  color: #fff;
  border-radius: 4px;
  padding: 2px 4px;
  margin-left: 14px;
}

.hot-text {
  color: #ff4049;
  font-size: 14px;
  margin-left: 5px;
  cursor: pointer;
}

.hot-text:active {
  color: #fd5760;
}

.cate-box {
  width: calc(100% + 20px);
  display: flex;
  flex-wrap: wrap;
}

.cate-item:hover {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

.cate-item {
  width: calc(25% - 20px);
  border-radius: 22px;
  display: flex;
  flex-flow: column;
  padding: 20px;
  margin-bottom: 20px;
  background: #fff;
  margin-right: 20px;
  position: relative;
}

.search-box {
  display: flex;
}

.kong-app {
  width: 100%;
  height: 500px;
  background: #fff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  border-radius: 22px;
  overflow: hidden;
  text-align: center;
  color: #999999;
  font-size: 16px;
  .kongImg {
    margin: 70px 0 50px;
    overflow: hidden;
  }
  img {
    display: inline-block;
  }
  .imgButton {
    background: #1890ff;
    display: inline-block;
    width: 110px;
    height: 37px;
    color: #fff;
    text-align: center;
    line-height: 37px;
    border-radius: 12px;
    margin-top: 50px;
  }
  .imgButton:active {
    background: #58adfd;
    cursor: pointer;
  }
}

@media screen and (max-width: 1450px) {
  .cate-item {
    width: calc(33.33% - 20px);
  }
}

@media screen and (max-width: 1050px) {
  .cate-item {
    width: calc(50% - 20px);
  }
}

@media screen and (max-width: 700px) {
  .cate-item {
    width: calc(100% - 20px);
  }
}
</style>